import React from 'react';
import { Table } from './styles';
import { Column } from '../../components/Table';
import { Row } from './interface';
import { getTag, setPositionOfRowExpanded } from '../../utils/tableUtils';

interface InclusionOfBeneficiariesTableProps {
  dataTable: Row[];
  templateRowExpanded: (data: Row) => JSX.Element;
  setRowExpanded: (rows: Row[]) => void;
  rowExpanded: Row[];
  onRowExpanded: (row: Row) => void;
  AddField: (value: string, label: string) => React.ReactNode;
}

export const InclusionOfBeneficiariesTable: React.FC<InclusionOfBeneficiariesTableProps> =
  ({
    dataTable,
    templateRowExpanded,
    setRowExpanded,
    rowExpanded,
    onRowExpanded,
    AddField,
  }) => {
    return (
      <Table
        items={dataTable}
        className="notiflix-table-loading"
        rowExpansionTemplate={templateRowExpanded}
        onRowToggle={(e) => {
          const row = e.data[e.data.length - 1];
          setRowExpanded([row]);
          if (row) onRowExpanded(row);
        }}
        onRowClick={(e) => {
          onRowExpanded(e.data);

          if (
            rowExpanded.length > 0 &&
            rowExpanded[0]?.requestId !== e.data?.requestId
          ) {
            setRowExpanded([]);
            return setRowExpanded([e.data]);
          }
          return rowExpanded.length === 0
            ? setRowExpanded([e.data])
            : setRowExpanded([]);
        }}
        expandedRows={rowExpanded}
        onRowExpand={(e) =>
          window.innerWidth <= 768 && setPositionOfRowExpanded(e.originalEvent)
        }
      >
        <Column
          field="requestId"
          header="Solicitação"
          sortable
          body={(data) => AddField(data.requestId, 'Solicitação')}
          style={{ width: '140px' }}
        />
        <Column
          field="beneficiary"
          header="Beneficiário"
          sortable
          body={(data) => AddField(data.beneficiaryName, 'Beneficiário')}
        />
        <Column
          field="holderName"
          header="Nome do Titular"
          sortable
          body={(data) => AddField(data.holderName, 'Nome do Titular')}
        />
        <Column
          field="solicitationData"
          header="Data de Solicitação"
          className="date"
          body={(data) =>
            AddField(data.solicitationDate, 'Data de Solicitação')
          }
        />
        <Column
          field="status"
          header="Status"
          className="tag"
          style={{ width: '150px' }}
          sortable
          body={(data) => {
            switch (data.status) {
              case 'Aguardando análise da Operadora':
              case 'Aguardando análise Operadora':
                return getTag(
                  'Status',
                  'Aguard. Análi. Operadora',
                  'orange',
                  data.status,
                );
              case 'Aguardando liberação':
                return getTag(
                  'Status',
                  'Aguard. Liberação',
                  'orange',
                  data.status,
                );
              case 'Contratação concluída':
                return getTag(
                  'Status',
                  'Contrat. Cocluída',
                  'green',
                  data.status,
                );
              case 'Em processo de finalização':
                return getTag(
                  'Status',
                  'Em Proces. Finalização',
                  'orange',
                  data.status,
                );
              case 'Solicitação com inconsistência':
                return getTag(
                  'Status',
                  'Solic. c/ Inconsistência',
                  'orange',
                  data.status,
                );
              case 'Solicitação em andamento':
                return getTag(
                  'Status',
                  'Solic. Em Andamento',
                  'orange',
                  data.status,
                );
              case 'Solicitação rejeitada pela operadora':
                return getTag('Status', 'Solic. Rejeitada', 'red', data.status);
              case 'Aguardando Análise da Declaração de Saúde':
                return getTag(
                  'Status',
                  'Aguard. Análi. Declar. Saúde',
                  'orange',
                  data.status,
                );
              case 'Solicitação cancelada':
                return getTag(
                  'Status',
                  'Solicitação Cancelada',
                  'gray',
                  data.status,
                );
              case 'Aguardando preenchimento do Funcionário':
                return getTag(
                  'Status',
                  'Aguard. Preench. Func.',
                  'orange',
                  data.status,
                );
              default:
                return getTag('Status', data.status, 'red', data.status);
            }
          }}
        />
        <Column expander headerStyle={{ width: '60px' }} />
      </Table>
    );
  };
